/*
© Copyright 2021 Orolabs.ai to present
* All rights reserved.
* Unauthorized copying of this file, via any medium is strictly prohibited.
* Proprietary and confidential.
* Author: 
*/

import type { SVGProps } from "react"

export default function ArrowLeft(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" {...props} fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2176 0.0668792C19.8219 -0.0653349 19.4534 0.0302782 19.2702 0.0834889C19.0706 0.141478 18.8326 0.234372 18.5939 0.327573L1.63685 6.94497C1.37002 7.04906 1.11157 7.14988 0.912093 7.24851C0.739736 7.33374 0.373398 7.52342 0.168911 7.91703C-0.0565912 8.35109 -0.0562872 8.86784 0.169726 9.30164C0.374675 9.69501 0.741235 9.88426 0.913692 9.96928C1.11328 10.0677 1.3718 10.1682 1.63874 10.2719L6.35877 12.1075C6.71089 12.2444 6.88695 12.3129 7.0621 12.3171C7.21692 12.3208 7.37049 12.2885 7.5107 12.2228C7.66932 12.1484 7.8029 12.0148 8.07005 11.7477L12.9155 6.90227C13.306 6.51174 13.9391 6.51174 14.3297 6.90227C14.7202 7.29279 14.7202 7.92596 14.3297 8.31648L9.48426 13.1619C9.21711 13.429 9.08354 13.5626 9.00914 13.7212C8.94339 13.8615 8.9111 14.015 8.91482 14.1698C8.91902 14.345 8.98749 14.521 9.12443 14.8732L10.96 19.5931C11.0637 19.8601 11.1642 20.1186 11.2627 20.3182C11.3477 20.4907 11.5369 20.8573 11.9303 21.0622C12.3641 21.2882 12.8808 21.2885 13.3149 21.063C13.7085 20.8585 13.8982 20.4922 13.9834 20.3198C14.082 20.1204 14.1829 19.862 14.2869 19.5951L20.9044 2.63799C20.9976 2.39928 21.0905 2.16136 21.1484 1.96172C21.2017 1.77854 21.2973 1.41008 21.1651 1.01431C21.0157 0.567161 20.6648 0.216257 20.2176 0.0668792Z"
        fill={props.fill || 'currentColor'}
      />
    </svg>
  )
}
